import { gql } from 'urql';

const SubmitBankApplication = gql`
  mutation SubmitBankApplication(
    $idempotencyId: String!
    $agreements: [ID!]!
    $applicationId: ID!
  ) {
    submitApplication(
      idempotencyId: $idempotencyId
      input: { agreements: $agreements, applicationId: $applicationId }
    ) {
      __typename
      ... on SubmitApplicationSuccess {
        application {
          id
        }
        tileIdsToRefresh
      }
      ... on SubmitApplicationError {
        code
        title
        message
      }
    }
  }
`;

export default SubmitBankApplication;
